import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AbstractCrudService} from '../shared/abstract-crud.service';
import {Linking} from './linking.model';

/**
 * Service for interacting with Linkings.
 */
@Injectable()
export class LinkingCrudService extends AbstractCrudService<Linking> {
  /**
   * URL for current model, override url from superclass
   * @type {string}
   */
  protected url = environment.regoApiURL + 'linkings';

  private linkings: Promise<Linking[]>;

  /**
   * Default constructor
   * @param {HttpClient} http - refined http service, automatically adds authentication token
   */
  constructor(protected http: HttpClient) {
    super(http);
  }

  private async getLinkings(): Promise<Linking[]> {
    if (!this.linkings) {
      this.linkings = this.list().then(result => result.data ?? [], () => []);
    }
    return this.linkings;
  }

  /**
   * find source system identifier that is linked to rego identifier.
   * if source system is not given, by default try to find rego id's linked to misonet
   * @param regoId
   * @param sourceSystem
   */
  public async getSourceIdForRegoId(regoId: string, sourceSystem: string): Promise<Linking> {
    return (await this.getLinkings()).find(o => {
      return `${o.regoId}` === `${regoId}` && `${o.sourceSystem}` === `${sourceSystem}`;
    });
  }

  public async getRegoIdForSourceId(sourceId: string | number): Promise<string> {
    return (await this.getLinkings()).find(o => {
      return `${o.sourceId}` === `${sourceId}`;
    })?.regoId;
  }

  public async getRegoIdForSourceIdPrefix(sourceId: string | number): Promise<string> {
    return (await this.getLinkings()).find(o => {
      return `${o.sourceId}`.startsWith(`${sourceId}`);
    })?.regoId;
  }

  public async getSourceIdPrefixesForRegoId(regoId: string | number, sourceSystem?: string): Promise<Set<string>> {
    return new Set((await this.getLinkings()).filter(o => {
      return o.regoId.toString() === regoId.toString() && (sourceSystem === undefined || o.sourceSystem === sourceSystem);
    }).map(linking => linking.sourceId.split(':')[0]));
  }
}
